<template>
  <div class="content_all">
    <div class="topWrap">
      <img :src="bannerImg" class="staticBanner" />
    </div>
    <div class="content_all">
      <!-- <banner :type="BannerType"></banner> -->
      <serve
        :sendData="item"
        :styleName="item.styleName"
        v-for="(item, index) in compoentList"
        :key="index"
      ></serve>
    </div>
    <!--
    <div class="serveWrap" v-for="(item,index) in compoentList" :key="index" :class="index==1?'serveHeight':''">
      <serve :cooper=false :sendData='item' :styleName='item.styleName' style="padding-bottom:0rem;"></serve>
       <div class="RassText" v-if="index==0">
         <p>完整的产品线</p>
         <p>成熟的产品 丰富的开发经验</p>
         <p>专业的服务</p>
       </div>
       <div class="imgWrap" v-if="index==1">
         <img src="../../assets/u5.svg">
         <img src="../../assets/u5.svg">
       </div>
    </div>
    <div class="prize">
      <p class="altitle">荣誉奖项</p>
    </div>
    -->
    <div class="lichengWrap">
      <p class="altitle">{{ $t("about.history") }}</p>
      <div class="licheng">
        <!-- <img src="../../assets/licheng.png" /> -->

        <div class="timeline-container">
          <div class="timeline-line"></div>
          <div
            class="timeline-item"
            v-for="(item, index) in timelineData"
            :key="index"
          >
            <div class="timeline-dot"></div>
            <div
              class="timeline-content"
              :class="{
                'content-right': index % 2 === 0,
                'content-left': index % 2 === 1,
              }"
              @mouseover="handleMouseOver(index)"
              @mouseleave="handleMouseLeave(index)"
            >
              <div class="year">{{ item.year }}</div>
              <div class="desc">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import serve from "../../components/customPart/serve.vue";
import axios from "../../api/axios";
export default {
  name: "produceSeries",
  components: {
    serve,
  },
  data() {
    return {
      bannerImg: require("../../assets/bner.png"),
      compoentList: [
        {
          styleName: "Rassemble",
          backGroud: "url(" + require("../../assets/u473.png") + ")",
          maxImg: require("../../assets/u5.svg"),
          title: "近二十年用心积累，提供最可靠的服务",
          content:
            "锐骐物联为全球物联网开发者打造物联网智能平台，连接消费者、制造品牌、OEM厂商和零售连锁的智能化需求，为客户解决开发成本高、周期长、难度大等难题，一站式实现“联网模块+云+电脑/手机控制端” 开发，让零基础的企业也能迅速进入智能领域。",
          productList: [
            {
              productImage: require("../../assets/1pro.png"),
              productName: "T1-BOX",
              productLink: "https://www.baidu.com/",
            },
            {
              productImage: require("../../assets/2pro.png"),
              productName: "T2-BOX",
              productLink: "https://www.baidu.com/",
            },
            {
              productImage: require("../../assets/3pro.png"),
              productName: "T3-BOX",
              productLink: "https://www.baidu.com/",
            },
          ],
        },
        {
          styleName: "introduce",
          title: "产品系列特点介绍",
          content:
            "锐骐物联为全球物联网开发者打造物联网智能平台，连接消费者、制造品牌、OEM厂商和零售连锁的智能化需求，为客户解决开发成本高、周期长、难度大等难题，一站式实现“联网模块+云+电脑/手机控制端” 开发，让零基础的企业也能迅速进入智能领域",
        },
      ],
      timelineData: [
        { year: "2024年", content: "北京锐骐赛格成立" },
        { year: "2023年", content: "江西分公司成立" },
        { year: "2020年", content: "福建重点科研研发机构" },
        { year: "2019年", content: "物联网孵化器认证" },
        { year: "2016年", content: "南宁分公司成立" },
        { year: "2014年", content: "荣获厦门市成长型企业" },
        { year: "2012年", content: "被评为国家火炬计划重点高新技术企业" },
        { year: "2010年", content: "2010年中国服务外包成长型企业百强之一" },
        {
          year: "2008年",
          content:
            "由一批在移动互联产品设计制造行业有10年以上经验的资深工程师创立",
        },
      ],
      hoveredIndex: null, // 用于记录悬停的索引
    };
  },
  created() {},
  mounted() {
    this.getAboutReach();
    this.getBannerImg();
  },
  methods: {
    getAboutReach() {
      var url = "/reach/portal/api/about/abouReach";
      axios
        .post(
          url,
          {},
          {
            params: {
              language: localStorage.getItem("locale"),
            },
          }
        )
        .then((response) => {
          if (response.data.code === 1) {
            this.compoentList = response.data.data;
          }
        });
    },
    getBannerImg() {
      var bannerType = "aboutReach";
      var url = "/reach/portal/api/homepage/getBannerList";
      axios
        .post(
          url,
          {},
          {
            params: {
              type: bannerType,
              language: localStorage.getItem("locale"),
            },
          }
        )
        .then((response) => {
          if (response.data.code) {
            this.bannerImg = response.data.data[0].adImage;
          }
        });
    },
    handleMouseOver(index) {
      this.hoveredIndex = index;
    },
    handleMouseLeave() {
      this.hoveredIndex = null;
    },
  },
};
</script>
<style scoped lang="less">
.content_all {
  padding-bottom: 2rem;
  .topWrap {
    margin-top: 1.5rem;
    position: relative;
    height: 240px;
    // background: url(../../assets/bner.png) no-repeat;
    background-size: cover;
    .innerTitle {
      position: absolute;
      top: 34%;
      left: 50%;
    }
  }
  .serveWrap {
    position: relative;
    .RassText {
      position: absolute;
      bottom: 23%;
      left: 9%;
      font-size: 0.3rem;
      p {
        margin-bottom: 0.16rem;
      }
    }
    .imgWrap {
      position: absolute;
      bottom: 24%;
      left: 28%;
      display: flex;
      width: 40%;
      height: 40%;
      img {
        width: 50%;
        margin-right: 1rem;
      }
    }
  }
  .serveHeight {
    height: 9rem;
  }
  .prize {
    height: 7rem;
  }
  .lichengWrap {
    .licheng {
      padding: 2% 0 2% 13%;
    }
  }
}

.timeline-container {
  position: relative;
  // margin: 0 auto;
  // max-width: 800px;

  .timeline-line {
    position: absolute;
    left: 43%;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #dbe7ef;
    //transform: translateX(-40%);
  }

  .timeline-item {
    position: relative;
    margin-bottom: 40px;

    .timeline-dot {
      position: absolute;
      left: 43%;
      top: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fff;
      border: 2px solid #409eff;
      box-shadow: 0 0 0 2px #409eff20;
      transform: translateX(-43%);
      z-index: 1;
    }

    // 右侧内容样式
    .content-right {
      width: 43%;
      margin-left: 43%;
      padding-left: 20px;
      text-align: left;
    }

    // 左侧内容样式
    .content-left {
      width: calc(43% - 30px);
      margin-right: 43%;
      padding-right: 20px;
      text-align: right;
    }

    .timeline-content {
      position: relative;
      padding: 10px 15px;
      // background-color: #f9f9f9;
      border-radius: 4px;
      transition: all 0.3s ease;
      .year {
        font-weight: bold;
        margin-bottom: 5px;
        color: #333;
        font-size: 20px;
      }

      .desc {
        color: #666;
        font-size: 16px;
      }
    }
  }
  .timeline-content:hover {
    background-color: #f0f0f0; /* 鼠标悬停时的背景色 */
    transform: scale(1.05); /* 放大效果 */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* 阴影效果 */
  }
  .timeline-content.content-right:hover {
    border-right: 3px solid #007bff; /* 右侧悬停效果 */
  }
  .timeline-content.content-left:hover {
    border-left: 3px solid #007bff; /* 左侧悬停效果 */
  }
  // 移动端适配
  @media (max-width: 768px) {
    .timeline-line {
      left: 20px;
    }

    .timeline-dot {
      left: 20px;
    }

    .timeline-item {
      .content-right,
      .content-left {
        width: calc(100% - 50px);
        margin-left: 40px;
        margin-right: 0;
        text-align: left;
        padding: 10px 15px;
      }

      .content-left::before,
      .content-right::before {
        left: -20px;
        right: auto;
      }
    }
  }
}
</style>
